import * as React from 'react';

import {
  Attachment,
  AttachmentAction,
  AttachmentActions,
  AttachmentContent,
  AttachmentDescription,
  AttachmentGroup,
  AttachmentMedia,
  AttachmentTitle,
  AttachmentTrigger,
} from './components/ui/attachment.js';
import { DimeSpinner } from './DimeSpinner.js';

type AttachmentState = 'idle' | 'uploading' | 'processing' | 'error' | 'done';

const AttachmentStateContext = React.createContext<AttachmentState>('done');

export function DimeAttachment({
  state = 'done',
  ...props
}: Readonly<React.ComponentProps<typeof Attachment>>) {
  return (
    <AttachmentStateContext.Provider value={state}>
      <Attachment state={state} {...props} />
    </AttachmentStateContext.Provider>
  );
}

export function DimeAttachmentGroup({
  ...props
}: Readonly<React.ComponentProps<typeof AttachmentGroup>>) {
  return <AttachmentGroup {...props} />;
}

export function DimeAttachmentMedia({
  children,
  ...props
}: Readonly<React.ComponentProps<typeof AttachmentMedia>>) {
  const state = React.useContext(AttachmentStateContext);
  const isLoading = state === 'uploading' || state === 'processing';

  return (
    <AttachmentMedia {...props}>
      {children ?? (isLoading ? <DimeSpinner data-slot="spinner" /> : null)}
    </AttachmentMedia>
  );
}

export function DimeAttachmentContent({
  ...props
}: Readonly<React.ComponentProps<typeof AttachmentContent>>) {
  return <AttachmentContent {...props} />;
}

export function DimeAttachmentTitle({
  ...props
}: Readonly<React.ComponentProps<typeof AttachmentTitle>>) {
  return <AttachmentTitle {...props} />;
}

export function DimeAttachmentDescription({
  ...props
}: Readonly<React.ComponentProps<typeof AttachmentDescription>>) {
  return <AttachmentDescription {...props} />;
}

export function DimeAttachmentActions({
  ...props
}: Readonly<React.ComponentProps<typeof AttachmentActions>>) {
  return <AttachmentActions {...props} />;
}

export function DimeAttachmentAction({
  ...props
}: Readonly<React.ComponentProps<typeof AttachmentAction>>) {
  return <AttachmentAction {...props} />;
}

export function DimeAttachmentTrigger({
  ...props
}: Readonly<React.ComponentProps<typeof AttachmentTrigger>>) {
  return <AttachmentTrigger {...props} />;
}
